import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../../../shared/services/alert.service';

@Component({
  selector: 'app-auth-container',
  templateUrl: './auth-container.component.html',
  styleUrls: ['./auth-container.component.scss'],
})
export class AuthContainerComponent implements OnInit, OnDestroy {
  public showAlert = 0;
  private alertSub: Subscription;

  constructor(private alertService: AlertService) {}

  public ngOnInit(): void {
    this.alertSub = this.alertService.showAlert$.subscribe(v => this.showAlert = v);
  }

  public ngOnDestroy(): void {
    this.alertSub.unsubscribe();
  }
}
